import React, { FC } from 'react';
import { ProjectDpTabHeaderProps } from './ProjectDPTabHeaderProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import Button from '@ingka/button';
import LinkOut from '@ingka/ssr-icon/paths/link-out';
import Divider from '../Divider';
import SsrIcon from '@ingka/ssr-icon';

const ProjectDpTabHeader: FC<ProjectDpTabHeaderProps> = ({
  decisionPoints,
}) => {
  return (
    <Stack spacing={1}>
      {decisionPoints?.length > 0 ? (
        <>
          <Stack flexDirection={'row'} gap={2} mt={3}>
            <Button
              type={'secondary'}
              size="small"
              href="https://vaxa.ingka.com/timelines"
              target="_blank"
              rel="noopener noreferrer"
            >
              Timeline dashboard
              <SsrIcon paths={LinkOut} />
            </Button>
            <Button
              type={'primary'}
              size="small"
              href={`https://invex.ingka.com/requests/${decisionPoints[0].requestId}`}
              target="_blank"
              rel="noopener noreferrer"
              iconPosition={'trailing'}
            >
              View project in Invex
              <SsrIcon paths={LinkOut} />
            </Button>
          </Stack>
          <Stack flexDirection={'row'} justifyContent={'space-between'} mt={3}>
            <Text textStyle="Body.M">
              Read more about Decision points in Växa
            </Text>
            <a
              href="https://vaxa.ingka.com/decisionpoints"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SsrIcon paths={LinkOut} />
            </a>
          </Stack>

          <Divider />
        </>
      ) : (
        <>
          <Text>
            Your project currently has no decision points. Begin by adding your
            project in Invex. If you want to learn more about the different
            Decision Points, visit Växa.
          </Text>
          <Stack flexDirection={'row'} gap={2} mt={3}>
            <Button
              type={'secondary'}
              size="small"
              href="https://vaxa.ingka.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read more in Växa
            </Button>
            <Button
              type={'primary'}
              size="small"
              href="https://invex.ingka.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Add project to Invex
            </Button>
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default ProjectDpTabHeader;
